<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/J4OFWt/cover.jpeg?1684245186266" alt="This image is the cover for the book Three Kingdoms: Super Hegemon, Volume 1"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Three Kingdoms: Super Hegemon, Volume 1
      </h1>
      <p class="bookDescription body article font2">
        <p><strong>At the beginning of the chaotic era, as a special forces soldier of the later generation, Luo Yang came to this chaotic era. </strong></p><p>Perhaps, surviving was the first problem that Luo Yang needed to solve! As long as he could survive, he was willing to do anything! If you don't let me live! Then I will kill you! Soldier? Snatch! An army? Snatch! A city? Snatch! A famous general? Snatch! Beautiful women? Snatch! Country? Snatch! The world? After snatching so much, the world was no longer taking it for granted!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Xiao XiaoMaJiaHao, Babel Novel
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Funstory
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0ba7ae86